import { mutateApi, queryApi } from "src/utils/api/ApiMethods"

export const getJobTemplate = (marinaSlug, id) =>
  queryApi(`/manage/${marinaSlug}/service/job_templates/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  })

export const createJobTemplate = (
  marinaSlug,
  { name, description, lineItems = [] }
) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/job_templates`,
    method: "POST",
    data: {
      job_template: {
        name,
        description,
        line_items: lineItems.map(({ productId, quantity }) => ({
          product_id: productId,
          quantity,
        })),
      },
    },
  }).then((response) => response.data)

export const updateJobTemplate = (
  marinaSlug,
  id,
  { name, description, lineItems = [] }
) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/job_templates/${id}`,
    method: "PATCH",
    data: {
      job_template: {
        name,
        description,
        line_items: lineItems.map(
          ({ id: itemId, productId, quantity, _destroy }) => ({
            id: itemId,
            product_id: productId,
            quantity,
            _destroy: !!_destroy,
          })
        ),
      },
    },
  }).then((response) => response.data)
